export const bankList = [
  {
    group: "은행", // 36개
    options: [
      { label: "국민은행", value: "국민은행" },
      { label: "신한은행", value: "신한은행" },
      { label: "우리은행", value: "우리은행" },
      { label: "하나은행", value: "하나은행" },
      { label: "기업은행", value: "기업은행" },
      { label: "농협은행", value: "농협은행" },
      { label: "우체국", value: "우체국" },
      { label: "카카오뱅크", value: "카카오뱅크" },
      { label: "토스뱅크", value: "토스뱅크" },
      { label: "케이뱅크", value: "케이뱅크" },

      { label: "새마을금고", value: "새마을금고" },
      { label: "신협", value: "신협" },
      { label: "부산은행", value: "부산은행" },
      { label: "광주은행", value: "광주은행" },
      { label: "도이치은행", value: "도이치은행" },
      { label: "산림조합", value: "산림조합" },
      { label: "제주은행", value: "제주은행" },
      { label: "전북은행", value: "전북은행" },
      { label: "경남은행", value: "경남은행" },
      { label: "SC제일은행", value: "SC제일은행" },

      { label: "iM뱅크", value: "iM뱅크" },
      { label: "수협은행", value: "수협은행" },
      { label: "수협중앙회", value: "수협중앙회" },
      { label: "저축은행", value: "저축은행" },
      { label: "씨티은행", value: "씨티은행" },
      { label: "KDB산업은행", value: "KDB산업은행" },
      { label: "SBI저축은행", value: "SBI저축은행" },
      { label: "BOA은행", value: "BOA은행" },
      { label: "중국건설은행", value: "중국건설은행" },
      { label: "중국공상은행", value: "중국공상은행" },

      { label: "중국은행", value: "중국은행" },
      { label: "지역농축협", value: "지역농축협" },
      { label: "뱅크오브아메리카", value: "뱅크오브아메리카" },
      { label: "BNP파리바은행", value: "BNP파리바은행" },
      { label: "JP모간체이스은행", value: "JP모간체이스은행" },
      { label: "HSBC은행", value: "HSBC은행" },
    ],
  },
  {
    group: "증권사", // 28개
    options: [
      { label: "교보증권", value: "교보증권" },
      { label: "우리투자증권", value: "우리투자증권" },
      { label: "다올투자증권", value: "다올투자증권" },
      { label: "대신증권", value: "대신증권" },
      { label: "메리츠증권", value: "메리츠증권" },
      { label: "미래에셋증권", value: "미래에셋증권" },
      { label: "부국증권", value: "부국증권" },
      { label: "삼성증권", value: "삼성증권" },
      { label: "상상인증권", value: "상상인증권" },
      { label: "신한투자증권", value: "신한투자증권" },
      { label: "유안타증권", value: "유안타증권" },
      { label: "유진투자증권", value: "유진투자증권" },
      { label: "카카오페이증권", value: "카카오페이증권" },
      { label: "케이프투자증권", value: "케이프투자증권" },
      { label: "키움증권", value: "키움증권" },
      { label: "토스증권", value: "토스증권" },
      { label: "하나증권", value: "하나증권" },
      { label: "한국투자증권", value: "한국투자증권" },
      { label: "한화투자증권", value: "한화투자증권" },
      { label: "현대차증권", value: "현대차증권" },
      { label: "BNK증권", value: "BNK증권" },
      { label: "DB증권", value: "DB증권" },
      { label: "IBK투자증권", value: "IBK투자증권" },
      { label: "iM증권", value: "iM증권" },
      { label: "KB증권", value: "KB증권" },
      { label: "LS증권", value: "LS증권" },
      { label: "NH투자증권", value: "NH투자증권" },
      { label: "SK증권", value: "SK증권" },
    ],
  },
];
